import { getAoiCrop } from './strategies/getAoiCrop.js';
import { getCenterCrop } from './strategies/getCenterCrop.js';
import { getSuggestedCrop } from './strategies/getSuggestedCrop.js';
import type { IContainer, IPhoto, IPhotoCrop, CropType } from '../common/types/index.js';

export function cropPhotoToContainer(photo: IPhoto, container: IContainer, cropStrategy?: CropType): IPhotoCrop {
    let crop: IPhotoCrop;

    switch (cropStrategy) {
        case 'aoi': {
            crop = getAoiCrop(photo, container) ?? getCenterCrop(photo, container);
            break;
        }

        case 'suggested': {
            crop = getSuggestedCrop(photo, container) ?? getCenterCrop(photo, container);
            break;
        }

        case 'center': {
            crop = getCenterCrop(photo, container);
            break;
        }

        case undefined: {
            crop = getAoiCrop(photo, container) ?? getSuggestedCrop(photo, container) ?? getCenterCrop(photo, container);
            break;
        }
    }

    return {
        x: crop.x / photo.width,
        y: crop.y / photo.height,
        width: crop.width / photo.width,
        height: crop.height / photo.height,
        rank: crop.rank,
    };
}
